import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';

@Directive({
  selector: '[appUppercase]'
})
export class UppercaseDirective {
  constructor(private el: ElementRef<HTMLInputElement>, private renderer: Renderer2) { }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const upper = (input.value ?? '').toUpperCase();
    const start = input.selectionStart;
    const end = input.selectionEnd;

    // Update native input
    this.renderer.setProperty(input, 'value', upper);

    // Restore cursor
    if (start !== null && end !== null) {
      input.setSelectionRange(start, end);
    }

    // Update Angular FormControl if present
    const control = (input as any).formControl;
    if (control && control.value !== upper) {
      control.setValue(upper, { emitEvent: false });
    }

    // Fallback for dynamic FormArray / FormGroup
    const formGroup = (input as any).formDirective as FormGroupDirective | NgForm;
    if (formGroup) {
      formGroup.control.patchValue({ [input.name]: upper }, { emitEvent: false });
    }
  }

  @HostListener('blur')
  onBlur() {
    const input = this.el.nativeElement;
    const upper = (input.value ?? '').toUpperCase();
    this.renderer.setProperty(input, 'value', upper);
  }
}